import { AppComponent } from "app/app.component";
import { GdprLicenseAgreementComponent, HeaderBarComponent, HomeComponent, LicenseAgreementComponent } from "app/core";
import {
  CardViewComponent,
  CardViewItemComponent,
  DashboardComponent,
  ListViewB2bComponent,
  ListViewComponent,
  ListViewItemB2bComponent,
  ListViewItemComponent
} from "app/dashboard";
import { MyAccountComponent } from "app/common/my-account/my-account.component";
import { UserChangeDataComponent } from "app/users";
import { PackageListComponent } from "app/payment/package-list/package-list.component";
import { PaymentConfirmationComponent } from "app/payment/payment-confirmation/payment-confirmation.component";
import { PaymentExecutionComponent } from "app/payment/payment-execution/payment-execution.component";
import { PaymentHistoryComponent } from "app/payment/payment-history/payment-history.component";
import { FormSelectComponent } from "app/common/form-select/form-select.component";
import { ChooseProfileComponent } from "app/statements/choose-profile/choose-profile.component";
import { PersonalInfoComponent } from "app/statements/personal-info/personal-info.component";
import { ThankYouComponent } from "app/statements/thank-you/thank-you.component";
import { AsideMenuComponent } from "app/core/aside-menu/aside-menu.component";
import { RefundDialogComponent } from "app/statements/refund-dialog/refund-dialog.component";
import { ClientDetailsComponent } from "app/batches/client-details/client-details.component";
import { ProcessingPlaceholderComponent } from "app/statements/processing-placeholder/processing-placeholder.component";
import { EmployerEditComponent } from "app/common/employer-edit/employer-edit.component";
import { ProfileEditComponent } from "app/common/profile-edit/profile-edit.component";
import { ProfileEditBcComponent } from "app/common/profile-edit-bc/profile-edit-bc.component";
import { PersonalInfoEditComponent } from "app/common/personal-info-edit/personal-info-edit.component";
import { EmployerFieldSummaryComponent } from "app/statements/employer-field-summary/employer-field-summary.component";
import { CongratulationsComponent } from "app/statements/congratulations/congratulations.component";
import { SendWithCertComponent } from "app/statements/send-with-cert/send-with-cert.component";
import { PaymentCheckoutComponent } from "app/statements/payment-checkout/payment-checkout.component";
import { UpsellPageComponent } from "app/statements/upsell-page/upsell-page.component";
import { PackageSelectionComponent } from "app/statements/package-selection/package-selection.component";
import { CollapseComponentComponent } from "app/shared/components/collapse-component/collapse-component.component";
import { SingleFieldEditComponent } from "app/common/single-field-edit/single-field-edit.component";
import { WorkflowStepsDialogComponent } from "app/common/workflow-steps-dialog/workflow-steps-dialog.component";
import { RemoveStatementDialogComponent } from "app/common/remove-statement-dialog/remove-statement-dialog.component";
import { DownloadFileDialogComponent } from "app/common/decision-dialog/download-file-dialog.component";
import { ConfirmationDialogComponent } from "app/common/confirmation-dialog/confirmation-dialog.component";
import { ErrorDialogComponent } from "app/common/error-dialog/error-dialog.component";
import { UpsellDialogComponent } from "app/statements/upsell-dialog/upsell-dialog.component";
import { ClientSummaryComponent } from "app/batches/client-summary/client-summary.component";
import { PaymentDetailsComponent } from "app/batches/payment-details/payment-details.component";
import { ChargesSummaryComponent } from "app/batches/charges-summary/charges-summary.component";
import { BuyCreditsDialogComponent } from "app/batches/buy-credits-dialog/buy-credits-dialog.component";
import { ThankYouBusinessComponent } from "app/batches/thank-you-business/thank-you-business.component";
import { CongratulationsBusinessComponent } from "app/batches/congratulations-business/congratulations-business.component";
import { CountryFieldComponent } from "app/common/country-field/country-field.component";
import { FormDateInputComponent } from "app/common/form-date-input/form-date-input.component";
import { DoubleFormDateInputComponent } from "app/common/double-form-date-input/double-form-date-input.component";
import { SendEwrAttachmentComponent } from "app/statements/send-ewr-attachment/send-ewr-attachment.component";
import { BankDetailsComponent } from "app/statements/bank-details/bank-details.component";
import { PaymentListComponent } from "app/payment/payment-list/payment-list.component";
import { PaymentListItemComponent } from "app/payment/payment-list-item/payment-list-item.component";
import { PaymentAbortComponent } from "app/payment/payment-abort/payment-abort.component";
import { PaymentTimeOutComponent } from "app/payment/payment-time-out/payment-time-out.component";
import { SortListComponent } from "app/common/sort-list/sort-list.component";
import { SearchEngineComponent } from "app/core/search-engine/search-engine.component";
import { PersonalInfoTaxAuthorityComponent } from "app/common/personal-info-tax-authority/personal-info-tax-authority.component";
import { ShowFormErrorDirective } from "app/common/show-form-error.directive";
import { TaxcardQualityInfoComponent } from "app/statements/taxcard-quality-info/taxcard-quality-info.component";
import { SendStatementOnfidoComponent } from "app/statements/send-statement-onfido/send-statement-onfido.component";
import { PaymentCancellationComponent } from "app/core/payment-cancellation/payment-cancellation.component";
import { PaymentCancellationEtxComponent } from "app/core/payment-cancellation-etx/payment-cancellation-etx.component";
import { FooterComponent } from "app/common/footer/footer.component";
import { ReceiveNewsletterDialogComponent } from "app/common/receive-newsletter-dialog/receive-newsletter-dialog.component";
import { ImpressumComponent } from "app/core/impressum/impressum.component";
import { PaginatorComponent } from "app/common/paginator/paginator.component";
import { PaymentBannerComponent } from "app/common/payment-banner/payment-banner.component";
import { PaymentRegulationsComponent } from "app/common/payment-regulations/payment-regulations.component";
import { RemoveBatchDialogComponent } from "app/common/remove-batch-dialog/remove-batch-dialog.component";
import { DownloadStatementComponent } from "app/statements/download-statement/download-statement.component";
import { FinishComponent } from "app/statements/finish/finish.component";
import { ShowPasswordDirective } from "app/common/show-password.directive";
import { LohnsteuerValidatorDialogComponent } from "app/statements/lohnsteuer-validator-dialog/lohnsteuer-validator-dialog.component";
import { TaxAdvisorLicenceComponent } from "app/core/tax-advisor-licence/tax-advisor-licence.component";
import { PrivacyPolicyEtxComponent } from "app/core/privacy-policy-etx/privacy-policy-etx.component";
import { GeneralTaxAdvisorRulesComponent } from "app/core/general-tax-advisor-rules/general-tax-advisor-rules.component";
import { PhoneNumberDialogComponent } from "app/common/phone-number-dialog/phone-number-dialog.component";
import { TaxAdviserFinishDialogComponent } from "app/common/tax-adviser-finish-dialog/tax-adviser-finish-dialog.component";
import { VollmachtInfoEditComponent } from "app/statements/vollmacht-info-edit/vollmacht-info-edit.component";
import { ValidatorErrorMessageComponent } from "app/core/form-validator/validator-error-message/validator-error-message.component";
import { AdditionalIncomeDialogComponent } from "app/common/additional-income-dialog/additional-income-dialog.component";
import { AdditionalIncomeDialogEditComponent } from "app/common/additional-income-dialog-edit/additional-income-dialog-edit.component";
import { OcrFailedDialogComponent } from "app/common/ocr-failed-dialog/ocr-failed-dialog.component";
import { WelcomeModalComponent } from "app/epicUp/welcome-modal/welcome-modal.component";
import { VollmachtAuthorizationComponent } from "app/statements/vollmacht-authorization/vollmacht-authorization.component";
import { ActivationComponent } from "app/core/activation/activation.component";
import { EmailVerificationDialogComponent } from "app/common/email-verification-dialog/email-verification-dialog.component";
import { BankDetailComponent } from "app/statements/bank-detail/bank-detail.component";
import { NewStatementDialogComponent } from "app/common/new-statement-dialog/new-statement-dialog.component";
import { AcceptAtthorneyDialogComponent } from "app/common/accept-atthorney-dialog/accept-atthorney-dialog.component";
import { AdditionalOptionsSteuerAcceptComponent } from "app/common/additional-options-steuer-accept/additional-options-steuer-accept.component";
import { MoreInfoTooltipDialogComponent } from "app/common/more-info-tooltip-dialog/more-info-tooltip-dialog.component";
import { AdditionalIncomeOptionsComponent } from "app/statements/additional-income-options/additional-income-options.component";
import { ListViewAttachmentsComponent } from "app/dashboard/list-view-attachments/list-view-attachments.component";
import { ListViewDownloadsComponent } from "app/dashboard/list-view-downloads/list-view-downloads.component";
import { DocumentRequestDialogComponent } from "app/dashboard/document-request-dialog/document-request-dialog.component";
import { TaxAdvisorAdditionalValidationComponent } from "app/statements/tax-advisor-additional-validation/tax-advisor-additional-validation.component";
import { TaxDocumentsComponent } from "app/statements/tax-documents/tax-documents.component";
import { FormMultiInputComponent } from "app/common/form-multiinput/form-multiinput.component";
import { ErrorMessageComponent } from "app/common/error-message/error-message.component";
import { ConfirmTaxReturnComponent } from "app/statements/confirm-tax-return/confirm-tax-return.component";
import { ConfirmNewPremiumPriceComponent } from "app/statements/confirm-new-premium-price/confirm-new-premium-price.component";
import { CtrTaxCardComponent } from "app/common/confirm-tax-return/ctr-tax-card/ctr-tax-card.component";
import { CtrAdditionalIncomeComponent } from "app/common/confirm-tax-return/ctr-additional-income/ctr-additional-income.component";
import { CtrPensionIncomeComponent } from "app/common/confirm-tax-return/ctr-pension-income/ctr-pension-income.component";
import { CtrPaymentInfoComponent } from "app/common/confirm-tax-return/ctr-payment-info/ctr-payment-info.component";
import { CtrFreelanceJobComponent } from "app/common/confirm-tax-return/ctr-freelance-job/ctr-freelance-job.component";
import { CtrCryptocurrencyComponent } from "app/common/confirm-tax-return/ctr-cryptocurrency/ctr-cryptocurrency.component";
import { CtrAbroadIncomeComponent } from "app/common/confirm-tax-return/ctr-abroad-income/ctr-abroad-income.component";
import { CtrPersonalInfoComponent } from "app/common/confirm-tax-return/ctr-personal-info/ctr-personal-info.component";
import { CtrChildrenComponent } from "app/common/confirm-tax-return/ctr-children/ctr-children.component";
import { CtrDeductionsComponent } from "app/common/confirm-tax-return/ctr-deductions/ctr-deductions.component";
import { CtrBaseComponent } from "app/common/confirm-tax-return/ctr-base.component";
import { CtrBaseInfoComponent } from "app/common/confirm-tax-return/ctr-base-info/ctr-base-info.component";
import { NoticeMessageComponent } from "app/common/notice-message/notice-message.component";
import { PaymentInfoComponent } from "app/common/payment-info/payment-info.component";
import { AttachmentViewRowComponent } from "app/common/attachment-view-row/attachment-view-row.component";
import { B2bAbroadIncomeEditComponent } from "app/common/b2b-abroad-income-edit/b2b-abroad-income-edit.component";
import { B2bAbroadIncomeInfoComponent } from "app/statements/b2b-abroad-income-info/b2b-abroad-income-info.component";
import { ValidationErrorsDialogComponent } from "app/common/validation-errors-dialog/validation-errors-dialog.component";
import { TaxCardsListComponent } from "app/common/tax-cards-list/tax-cards-list.component";
import { TaxCardSingleRowComponent } from "app/common/tax-card-single-row/tax-card-single-row.component";
import { TaxCardComponent } from "app/statements/tax-card/tax-card.component";
import { CtrBankDetailComponent } from "app/common/confirm-tax-return/ctr-bank-detail/ctr-bank-detail.component";
import { CookiesLawBannerComponent } from "app/core/components/cookies-law-banner/cookies-law-banner.component";
import { CookiesLawDialogComponent } from "app/core/components/cookies-law-dialog/cookies-law-dialog.component";
import { IdentityVerificationComponent } from "app/statements/identity-verification/identity-verification.component";
import { IdentityVerificationResetDialogComponent } from "app/common/identity-verification-reset-dialog/identity-verification-reset-dialog.component";
//tooltips templates
import { PackageInfoTooltipTemplate } from "app/common/tooltip-templates/package-info/tooltip-template-package-info.component";
import { HomeServiceTooltipTemplate } from "app/common/tooltip-templates/home-service/tooltip-template-home-service.component";
import { VolunteringIncomeTooltipTemplate } from "app/common/tooltip-templates/voluntering-income/home-service/tooltip-voluntering-income.component";
import { PayWithdrawTooltipTemplate } from "app//common/tooltip-templates/pay-withdraw/tooltip-template-pay-withdraw.component";
import { BusinessRealEstateTooltipTemplate } from "app//common/tooltip-templates/bussiness-real-estate/tooltip-template-business-real-estate.component";
import { CostsTooltipTemplate } from "app/common/tooltip-templates/costs/tooltip-template-costs.component";
import { NewsletterResignationInfoComponent } from "app/core/newsletter-update/newsletter-resignation-info.component";
import { SendCertificateComponent } from "app/statements/send-certificate/send-certificate.component";
export const appModuleDeclarations = [
  AppComponent,
  HomeComponent,
  DashboardComponent,
  HeaderBarComponent,
  MyAccountComponent,
  UserChangeDataComponent,
  PackageListComponent,
  PaymentConfirmationComponent,
  PaymentExecutionComponent,
  PaymentHistoryComponent,
  FormSelectComponent,
  ChooseProfileComponent,
  PersonalInfoComponent,
  ThankYouComponent,
  SendCertificateComponent,
  IdentityVerificationComponent,
  IdentityVerificationResetDialogComponent,
  AsideMenuComponent,
  RefundDialogComponent,
  ClientDetailsComponent,
  ProcessingPlaceholderComponent,
  EmployerEditComponent,
  ProfileEditComponent,
  ProfileEditBcComponent,
  PersonalInfoEditComponent,
  ListViewComponent,
  ListViewB2bComponent,
  CardViewComponent,
  CardViewItemComponent,
  ListViewItemComponent,
  ListViewItemB2bComponent,
  EmployerFieldSummaryComponent,
  CongratulationsComponent,
  SendWithCertComponent,
  UpsellPageComponent,
  PaymentCheckoutComponent,
  PackageSelectionComponent,
  CollapseComponentComponent,
  SingleFieldEditComponent,
  WorkflowStepsDialogComponent,
  RemoveStatementDialogComponent,
  DownloadFileDialogComponent,
  ConfirmationDialogComponent,
  ErrorDialogComponent,
  UpsellDialogComponent,
  ClientSummaryComponent,
  PaymentDetailsComponent,
  ChargesSummaryComponent,
  BuyCreditsDialogComponent,
  ThankYouBusinessComponent,
  CongratulationsBusinessComponent,
  CountryFieldComponent,
  FormDateInputComponent,
  DoubleFormDateInputComponent,
  SendEwrAttachmentComponent,
  BankDetailsComponent,
  PaymentListComponent,
  PaymentListItemComponent,
  PaymentAbortComponent,
  PaymentTimeOutComponent,
  SortListComponent,
  SearchEngineComponent,
  LicenseAgreementComponent,
  PersonalInfoTaxAuthorityComponent,
  ShowFormErrorDirective,
  TaxcardQualityInfoComponent,
  SendStatementOnfidoComponent,
  PaymentCancellationComponent,
  PaymentCancellationEtxComponent,
  FooterComponent,
  ReceiveNewsletterDialogComponent,
  ImpressumComponent,
  PaginatorComponent,
  GdprLicenseAgreementComponent,
  PaymentBannerComponent,
  PaymentRegulationsComponent,
  RemoveBatchDialogComponent,
  DownloadStatementComponent,
  FinishComponent,
  ShowPasswordDirective,
  LohnsteuerValidatorDialogComponent,
  TaxAdvisorLicenceComponent,
  PrivacyPolicyEtxComponent,
  GeneralTaxAdvisorRulesComponent,
  PhoneNumberDialogComponent,
  TaxAdviserFinishDialogComponent,
  VollmachtInfoEditComponent,
  ValidatorErrorMessageComponent,
  AdditionalIncomeDialogComponent,
  AdditionalIncomeDialogEditComponent,
  OcrFailedDialogComponent,
  WelcomeModalComponent,
  VollmachtAuthorizationComponent,
  ActivationComponent,
  EmailVerificationDialogComponent,
  BankDetailComponent,
  NewStatementDialogComponent,
  AcceptAtthorneyDialogComponent,
  AdditionalOptionsSteuerAcceptComponent,
  MoreInfoTooltipDialogComponent,
  AdditionalIncomeOptionsComponent,
  ListViewAttachmentsComponent,
  ListViewDownloadsComponent,
  DocumentRequestDialogComponent,
  TaxAdvisorAdditionalValidationComponent,
  TaxDocumentsComponent,
  FormMultiInputComponent,
  ErrorMessageComponent,
  ConfirmTaxReturnComponent,
  ConfirmNewPremiumPriceComponent,
  CtrTaxCardComponent,
  CtrAdditionalIncomeComponent,
  CtrPensionIncomeComponent,
  CtrPaymentInfoComponent,
  CtrFreelanceJobComponent,
  CtrCryptocurrencyComponent,
  CtrAbroadIncomeComponent,
  CtrPersonalInfoComponent,
  CtrChildrenComponent,
  CtrDeductionsComponent,
  CtrBaseComponent,
  CtrBaseInfoComponent,
  ErrorMessageComponent,
  NoticeMessageComponent,
  PaymentInfoComponent,
  AttachmentViewRowComponent,
  B2bAbroadIncomeEditComponent,
  B2bAbroadIncomeInfoComponent,
  ValidationErrorsDialogComponent,
  TaxCardsListComponent,
  TaxCardSingleRowComponent,
  TaxCardComponent,
  CtrBankDetailComponent,
  CookiesLawBannerComponent,
  CookiesLawDialogComponent,
  NewsletterResignationInfoComponent,
  //tooltip templates
  PackageInfoTooltipTemplate,
  HomeServiceTooltipTemplate,
  VolunteringIncomeTooltipTemplate,
  PayWithdrawTooltipTemplate,
  BusinessRealEstateTooltipTemplate,
  CostsTooltipTemplate
];
